const OmniFinance = /* @__PURE__ */ (function() {
  let state = {
    config: {},
    apiData: null,
    currentAmount: 0,
    selectedOptionIndex: 0,
    selectedDepositValue: 0
  };
  const math = {
    roundPrice: (val) => Number(Math.round(val + "e2") + "e-2").toFixed(2),
    roundUp: (val) => Number(Math.ceil(val + "e2") + "e-2").toFixed(2),
    roundDown: (val) => Number(Math.floor(val + "e2") + "e-2").toFixed(2)
  };
  function parsePrice(str) {
    if (!str) return 0;
    return parseFloat(str.replace(/[^0-9.-]+/g, ""));
  }
  async function fetchOptions() {
    const url = `https://angus.finance-calculator.co.uk/api/public/finance-options?loan_amount=${state.currentAmount}&api_key=${state.config.apiKey}`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      if (data.finance_available) {
        state.apiData = data;
        state.selectedOptionIndex = 0;
        const defaultOption = data.finance_options[0];
        state.selectedDepositValue = parseFloat(defaultOption.deposit_options[0].value);
        renderAnchor();
      } else {
        removeWidget();
      }
    } catch (e) {
      console.error("Omni Finance Error:", e);
    }
  }
  function calculateFinance(optionIndex, depositValue) {
    const index = optionIndex !== void 0 ? optionIndex : state.selectedOptionIndex;
    const option = state.apiData.finance_options[index];
    const rate = option.imega_finance_rate;
    const purchasePrice = parseFloat(state.currentAmount);
    const depositPercentage = depositValue !== void 0 ? parseFloat(depositValue) : parseFloat(state.selectedDepositValue);
    const fixedDeposit = parseFloat(rate.fixed_deposit_amount);
    const depositAmount = fixedDeposit ? fixedDeposit : parseFloat(math.roundUp(purchasePrice * depositPercentage));
    const creditAmount = parseFloat(
      math.roundDown(purchasePrice - depositAmount)
    );
    const loadFactor = parseFloat(rate.load_factor);
    const installmentAmount = parseFloat(
      math.roundDown(creditAmount * loadFactor)
    );
    const term = parseInt(rate.term);
    const apr = parseFloat(rate.apr);
    const repaymentAmount = parseFloat(
      math.roundPrice(installmentAmount * term)
    );
    const totalPayable = parseFloat(
      math.roundPrice(
        apr === 0 ? purchasePrice : repaymentAmount + depositAmount
      )
    );
    const interestAmount = parseFloat(
      math.roundPrice(totalPayable - purchasePrice)
    );
    return {
      purchasePrice: math.roundPrice(purchasePrice),
      depositAmount: math.roundPrice(depositAmount),
      creditAmount: math.roundPrice(creditAmount),
      monthlyPayment: math.roundPrice(installmentAmount),
      term,
      interestRate: rate.apr,
      interestAmount: math.roundPrice(interestAmount),
      totalPayable: math.roundPrice(totalPayable)
    };
  }
  function lowestMonthlyPayment() {
    return state.apiData.finance_options.reduce((lowest, opt, i) => {
      const depositValue = parseFloat(opt.deposit_options[0].value);
      const monthly = parseFloat(calculateFinance(i, depositValue).monthlyPayment);
      return monthly < lowest ? monthly : lowest;
    }, Infinity).toFixed(2);
  }
  function renderAnchor() {
    let anchor = document.getElementById("omni-widget-container");
    const lowestMonthly = lowestMonthlyPayment();
    if (!anchor) {
      anchor = document.createElement("div");
      anchor.id = "omni-widget-container";
      if (state.config.containerId) {
        const container = document.getElementById(state.config.containerId);
        if (container) container.appendChild(anchor);
      } else {
        const target = document.querySelector(state.config.priceElement);
        if (target)
          target.insertAdjacentElement(
            state.config.insertion || "afterend",
            anchor
          );
      }
    }
    anchor.innerHTML = `
      <div class="flex items-center gap-4">

        <div class="flex flex-col">
          <div class="flex gap-1 m-0 leading-[1em] text-[12px]">
            <div class="text-[12px]">Pay from <strong class="text-[12px]">£${lowestMonthly}</strong> per month.</div>
            <a id="omni-trigger-btn" class="shrink-0 cursor-pointer rounded border-0 px-0 py-0 text-[12px] text-black font-bold transition-colors duration-200 hover:text-blue-600">
              ${state.config.buttonText || "Learn More"}
            </a>
          </div>
          <p class="m-0 leading-tight text-[11px] opacity-70">Subject to details. Conditions apply.</p>
        </div>
           <div class="px-2 py-2 bg-gray-100 rounded-md">
         <img src="${state.apiData.widget_options.header_img}" alt="Omni Finance" class="" style="height:24px">
         </div>
      </div>
    `;
    document.getElementById("omni-trigger-btn").addEventListener("click", openModal);
  }
  function updateModalTable() {
    const calc = calculateFinance();
    document.getElementById("omni-val-price").innerText = `£${calc.purchasePrice}`;
    document.getElementById("omni-val-deposit").innerText = `£${calc.depositAmount}`;
    document.getElementById("omni-val-credit").innerText = `£${calc.creditAmount}`;
    document.getElementById("omni-val-monthly").innerText = `£${calc.monthlyPayment}`;
    document.getElementById("omni-val-term").innerText = `${calc.term} Months`;
    document.getElementById("omni-val-apr").innerText = `${calc.interestRate}%`;
    document.getElementById("omni-val-interest").innerText = `£${calc.interestAmount}`;
    document.getElementById("omni-val-total").innerText = `£${calc.totalPayable}`;
  }
  function renderModal() {
    if (document.getElementById("omni-modal-wrapper")) return;
    const th = "px-2.5 py-2 border-b border-l border-gray-100 text-sm text-left text-gray-500 font-normal";
    const td = "px-2.5 py-2 border-b border-l border-gray-100 text-sm text-right font-bold text-gray-900";
    const modalHtml = `
      <div id="omni-modal-wrapper"
        class="fixed inset-0 flex items-center justify-center transition-opacity duration-300"
        style="background:rgba(0,0,0,0.6);z-index:999999;opacity:0;pointer-events:none">
        <div class="relative w-full overflow-hidden rounded-lg bg-white shadow-2xl transition-transform duration-300"
          style="max-width:500px;transform:translateY(20px)">
          <button type="button" id="omni-close-btn"
            class="absolute right-4 top-4 cursor-pointer border-0 bg-transparent text-2xl leading-none text-gray-400">
            &times;
          </button>
          <div class="border-b border-gray-200 bg-gray-100 p-5 text-center">
            <img src="${state.apiData.widget_options.header_img}" alt="Omni Finance" class="mb-2.5 object-contain" style="max-height:40px">
            <h3 class="m-0 text-lg text-gray-800">Finance Calculator</h3>
          </div>
          <div class="p-5">
            <div class="mb-5 flex gap-2.5">
              <select id="omni-select-product" class="flex-1 rounded border border-gray-300 p-2.5 text-sm"></select>
            </div>
            <table class="w-full border-collapse">
              <tbody>
                <tr><th class="${th}">Purchase Price</th><td class="${td}" id="omni-val-price"></td></tr>
                <tr><th class="${th}">Deposit Amount</th><td class="${td}" id="omni-val-deposit"></td></tr>
                <tr><th class="${th}">Amount of Credit</th><td class="${td}" id="omni-val-credit"></td></tr>
                <tr><th class="${th}">Monthly Repayment</th><td class="${td}" id="omni-val-monthly"></td></tr>
                <tr><th class="${th}">Term</th><td class="${td}" id="omni-val-term"></td></tr>
                <tr><th class="${th}">Representative APR</th><td class="${td}" id="omni-val-apr"></td></tr>
                <tr><th class="${th}">Total Interest</th><td class="${td}" id="omni-val-interest"></td></tr>
                <tr><th class="${th}">Total Amount Payable</th><td class="${td}" id="omni-val-total"></td></tr>
              </tbody>
            </table>
          </div>
          <div class="border-t border-gray-100 bg-gray-50 px-5 py-3.5 text-center text-[11px] text-gray-400">
            ${state.apiData.widget_options.footer_text || "Subject to status. Terms and conditions apply."}
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML("beforeend", modalHtml);
    const productSelect = document.getElementById("omni-select-product");
    state.apiData.finance_options.forEach((opt, index) => {
      productSelect.insertAdjacentHTML(
        "beforeend",
        `<option value="${index}">${opt.name}</option>`
      );
    });
    productSelect.addEventListener("change", (e) => {
      state.selectedOptionIndex = parseInt(e.target.value, 10);
      const newOption = state.apiData.finance_options[state.selectedOptionIndex];
      state.selectedDepositValue = parseFloat(newOption.deposit_options[0].value);
      updateModalTable();
      renderAnchor();
    });
    document.getElementById("omni-close-btn").addEventListener("click", closeModal);
    document.getElementById("omni-modal-wrapper").addEventListener("click", (e) => {
      if (e.target.id === "omni-modal-wrapper") closeModal();
    });
  }
  function openModal() {
    renderModal();
    updateModalTable();
    const overlay = document.getElementById("omni-modal-wrapper");
    const modal = overlay.firstElementChild;
    overlay.style.opacity = "1";
    overlay.style.pointerEvents = "auto";
    modal.style.transform = "translateY(0)";
  }
  function closeModal() {
    const overlay = document.getElementById("omni-modal-wrapper");
    const modal = overlay.firstElementChild;
    overlay.style.opacity = "0";
    overlay.style.pointerEvents = "none";
    modal.style.transform = "translateY(20px)";
  }
  function removeWidget() {
    const anchor = document.getElementById("omni-widget-container");
    if (anchor) anchor.remove();
  }
  function setupPriceObserver() {
    const priceElement = document.querySelector(state.config.priceElement);
    if (!priceElement) return;
    const observer = new MutationObserver(() => {
      const newAmount = parsePrice(priceElement.innerText);
      if (newAmount > 0 && newAmount !== state.currentAmount) {
        state.currentAmount = newAmount;
        fetchOptions();
      }
    });
    observer.observe(priceElement, {
      characterData: true,
      childList: true,
      subtree: true
    });
  }
  return {
    init: function(options) {
      state.config = options;
      if (options.initialAmount) {
        state.currentAmount = parseFloat(options.initialAmount);
        if (state.currentAmount > 0) {
          fetchOptions();
        }
      } else {
        const priceEl = document.querySelector(options.priceElement);
        if (priceEl) {
          state.currentAmount = parsePrice(priceEl.innerText);
          if (state.currentAmount > 0) {
            fetchOptions();
          }
        } else {
          console.warn("Omni Finance: Price element not found.");
        }
      }
      if (options.priceElement) {
        setupPriceObserver();
      }
    }
  };
})();
window.OmniFinance = OmniFinance;
